"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopulatedIntegrationSource = exports.EMMiIntegrationStatus = void 0;
var EMMiIntegrationStatus;
(function (EMMiIntegrationStatus) {
    /** videos transcoding. playlist items not stored to playlists */
    EMMiIntegrationStatus["transcoding"] = "transcoding";
    /** transcoding done and playlist items storet to playlists */
    EMMiIntegrationStatus["ready"] = "ready";
    /** transcoding failed */
    EMMiIntegrationStatus["failed"] = "failed";
})(EMMiIntegrationStatus = exports.EMMiIntegrationStatus || (exports.EMMiIntegrationStatus = {}));
/**
 * Source of populated content (playlist, media)
 */
var PopulatedIntegrationSource;
(function (PopulatedIntegrationSource) {
    PopulatedIntegrationSource["emmi"] = "emmi";
})(PopulatedIntegrationSource = exports.PopulatedIntegrationSource || (exports.PopulatedIntegrationSource = {}));
//# sourceMappingURL=integrations.js.map